import { motion } from "framer-motion";
import { ShieldCheck, Users, Building2 } from "lucide-react";

const STATS = [
  { value: "200+", label: "Ontario families & businesses", icon: Users },
  { value: "40+", label: "Carrier partners", icon: Building2 },
  { value: "RIBO", label: "Licensed insurance broker · Ontario", icon: ShieldCheck },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="bg-forest-800 border-y border-bone-100/10 py-10 md:py-14 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
        {STATS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="flex items-center gap-5"
              data-testid={`trust-stat-${i}`}
            >
              <div className="w-14 h-14 flex items-center justify-center border border-terracotta-500/40 bg-forest-900 text-terracotta-500 shrink-0">
                <Icon size={22} />
              </div>
              <div>
                <div className="font-serif text-3xl md:text-4xl text-bone-100 leading-none">
                  {s.value}
                </div>
                <div className="overline text-bone-100/60 mt-2">{s.label}</div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
